import { render, staticRenderFns } from "./ClientsHistory.vue?vue&type=template&id=142c8317&"
import script from "./ClientsHistory.vue?vue&type=script&lang=js&"
export * from "./ClientsHistory.vue?vue&type=script&lang=js&"
import style0 from "./ClientsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports